// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"524":"8775546d","580":"fd624799"}[chunkId] + ".chunk.css";
};